module.exports = __webpack_public_path__ + "static/media/login_bg.59e805a3.png";